import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

class BackgroundDataStoreUpdater extends Component {


    render(){
        return(
            <div></div> 
        )
    }
    constructor (props) {
        super(props)
        // If startOnMount is set, idle state defaults to true
        this.timeoutDuration = 1000 * 60 * 10
        this.startTimer()
    }
    componentWillUnmount () {
        clearTimeout(this.tId)
    }
    startTimer(){
        this.tId = setTimeout(this.timeout.bind(this), this.timeoutDuration) // set a new timeout
    }
    timeout(){
        const { club_number } = this.props.DGRStore
        if (club_number){
            this.props.DGRProductStore.getClubProductsSilent(club_number)
        }
        this.tId = setTimeout(this.timeout.bind(this), this.timeoutDuration) // set a new timeout
    }
}

BackgroundDataStoreUpdater = inject('DGRStore','DGRProductStore')(observer(BackgroundDataStoreUpdater  ))     
export default BackgroundDataStoreUpdater



// WEBPACK FOOTER //
// ./src/components/DGR/BackgroundDataStoreUpdater/BackgroundDataStoreUpdater.js